import { Directive, Input, OnInit, OnDestroy, ElementRef, Renderer2 } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Directive({ selector: '[countdown]' })
export class CountdownDirective implements OnInit, OnDestroy {
  @Input('countdown') targetDate: string = '';
  intervalId: any;

  constructor(private translocoService: TranslocoService, private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit(): void {
    // This Observable is used to prevent the countdown from repeatedly alternating 
    // between the old language and the new one when the language is changed
    this.translocoService.langChanges$.subscribe(() => {
      clearInterval(this.intervalId);
    });

    if (/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}$/.test(this.targetDate)) {
      let parts = this.targetDate.split(" ");
      let dateParts = parts[0].split("-");
      let timeParts = parts[1].split(":");
      let year = parseInt(dateParts[2], 10);
      let month = parseInt(dateParts[1], 10) - 1;
      let day = parseInt(dateParts[0], 10);
      let hours = parseInt(timeParts[0], 10);
      let minutes = parseInt(timeParts[1], 10);
      const input_date = new Date(year, month, day, hours, minutes);
      this.translocoService.selectTranslate(['offer_expiring', 'offer_expired']).subscribe(messages => {
        this.intervalId = setInterval(() => {
          const now = new Date().getTime();
          const distance = input_date.getTime() - now;

          if (distance > 0) {
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);
            this.renderer.setProperty(this.el.nativeElement, 'innerText', messages[0].replace('%days_left%', days).replace('%hours_left%', hours).replace('%minutes%', minutes).replace('%seconds%', seconds));
          } else {
            this.renderer.setProperty(this.el.nativeElement, 'innerText', messages[1].replace('%date%', this.targetDate));
            clearInterval(this.intervalId);
          }
        }, 1000);
      }); 
    } else {
      this.renderer.setProperty(this.el.nativeElement, 'innerText', this.targetDate);
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

}
